/**
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import { c as createSVGComponent } from '../utils-9450cd75.js';
import '@carbon/icon-helpers';
import 'vue';

const ChevronDownGlyph = createSVGComponent('ChevronDownGlyph', {
  "xmlns": "http://www.w3.org/2000/svg",
  "viewBox": "0 0 10 6",
  "fill": "currentColor",
  "width": "10",
  "height": "6"
}, [{
  "elem": "path",
  "attrs": {
    "d": "M5 6L0 1 0.7 0.3 5 4.6 9.3 0.3 10 1z"
  }
}]);

export { ChevronDownGlyph as default };
